module.exports = "./img/bd868aa32f033478019df08562de371b.png";